// extracted by mini-css-extract-plugin
export default {"list":"KuR3m","mobileList":"gQDAI"};